import { FC } from 'react';
import { img } from '@/helpers/utils';
import FingerUpIcon from '@/assets/svg/ico_finger_up.svg?react';
import Button from '@/components/controls/Button/Button.component';
import ModalSheet from '@/components/interactive/ModalSheet/ModalSheet.component';
import { IMAGES_LIST } from '@/components/widgets/AddPhotoWidget/MakePhotoBetterInfoModal/MakePhotoBetterInfoModal.config';
import styles from '@/components/widgets/AddPhotoWidget/MakePhotoBetterInfoModal/MakePhotoBetterInfoModal.module.scss';
import { MakePhotoBetterInfoModalPropsIF } from '@/components/widgets/AddPhotoWidget/MakePhotoBetterInfoModal/MakePhotoBetterInfoModal.types';

const MakePhotoBetterInfoModal: FC<MakePhotoBetterInfoModalPropsIF> = ({
    onclose,
}) => (
    <ModalSheet
        classNameBody={styles.modal}
        onClose={onclose}
        dataTest="make_photo_better_info_modal"
    >
        <div className="flcol gapBlock">
            <h2 className={styles.title}>Рекомендации для фото</h2>
            <div className={`flc ${styles.imagesList}`}>
                {IMAGES_LIST.map(({ guid, isLike }) => (
                    <div
                        key={guid}
                        className={`bgc ${styles.image}`}
                        style={{
                            backgroundImage: `url(${img(guid)})`,
                        }}
                    >
                        <div
                            className={`flc ${styles.icon} ${isLike ? styles.like : ''}`}
                        >
                            <FingerUpIcon />
                        </div>
                    </div>
                ))}
            </div>
            <div className={styles.description}>
                Чем качественнее фото, тем точнее мы определим категорию и
                другие детали изделия
            </div>
            <Button
                className={styles.clotheButton}
                dataTest="close_make_photo_better_info_modal_button"
                clickHandler={onclose}
            >
                Понятно
            </Button>
        </div>
    </ModalSheet>
);

export default MakePhotoBetterInfoModal;
